import { render, staticRenderFns } from "./GenePosition.vue?vue&type=template&id=0774095f&scoped=true&"
import script from "./GenePosition.vue?vue&type=script&lang=js&"
export * from "./GenePosition.vue?vue&type=script&lang=js&"
import style0 from "./GenePosition.vue?vue&type=style&index=0&id=0774095f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0774095f",
  null
  
)

export default component.exports